// Keep the `.dark` class in sync with the device's light/dark setting.
export function initSystemTheme() {
  if (typeof window === "undefined" || !window.matchMedia) return;
  try { localStorage.removeItem("theme"); } catch { /* ignore */ }
  const mq = window.matchMedia("(prefers-color-scheme: dark)");
  const apply = () => document.documentElement.classList.toggle("dark", mq.matches);
  apply();
  mq.addEventListener?.("change", apply);
}
